export default __webpack_public_path__ + "static/media/background.643d54eaa045dab1c349839a0fdeffe2.svg";